import { persistObject, readObject } from "../../../services/storage"
import { AppContentsData } from "../state/types"

const APP_DATA_KEY = "_app_data"

export const getDataCached = () => readObject<AppContentsData>(APP_DATA_KEY)

export const setDataCache = (data: AppContentsData) =>
  persistObject(APP_DATA_KEY, data)
